<template>
  <web-map></web-map>
</template>

<script>
import WebMap from '@/components/web-map.vue';

const vueName = 'MapView';
export default {
  name: vueName,
  components: {
    WebMap
  }
};
</script>

<style scoped></style>
